import { useState, useEffect } from 'react';

const CART_KEY = 'safaridew_cart';

const useCart = () => {
    const [cart, setCart] = useState(() => {
        try {
            const saved = localStorage.getItem(CART_KEY);
            return saved ? JSON.parse(saved) : [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem(CART_KEY, JSON.stringify(cart));
    }, [cart]);

    const addToCart = (product, selectedOptions = {}) => {
        setCart((prev) => {
            // Create a unique key for this product + variant combination
            const optionsString = Object.entries(selectedOptions)
                .sort(([a], [b]) => a.localeCompare(b))
                .map(([k, v]) => `${k}:${v}`)
                .join('|');
            
            const cartId = optionsString ? `${product.id}-${optionsString}` : String(product.id);

            const existing = prev.find((i) => i.cartId === cartId);
            if (existing) {
                return prev.map((i) =>
                    i.cartId === cartId ? { ...i, qty: i.qty + 1 } : i
                );
            }
            
            // Calculate final price with modifiers
            let finalPrice = product.price;
            if (product.options) {
                Object.entries(selectedOptions).forEach(([optId, valId]) => {
                    const option = product.options.find(o => o.id === optId);
                    const value = option?.values.find(v => v.id === valId);
                    if (value?.priceModifier) {
                        finalPrice += value.priceModifier;
                    }
                });
            }

            return [...prev, { ...product, cartId, selectedOptions, price: finalPrice, qty: 1 }];
        });
    };

    const removeFromCart = (cartId) => {
        setCart((prev) => prev.filter((i) => i.cartId !== cartId));
    };

    const updateQty = (cartId, qty) => {
        if (qty <= 0) {
            removeFromCart(cartId);
        } else {
            setCart((prev) =>
                prev.map((i) => (i.cartId === cartId ? { ...i, qty } : i))
            );
        }
    };

    const cartCount = cart.reduce((s, i) => s + i.qty, 0);

    return { cart, cartCount, addToCart, removeFromCart, updateQty };
};

export default useCart;
